import React from 'react';
import { InView } from 'react-intersection-observer';
import '../styles/CloudAdoptionHero.css';

const CloudAdoptionHero = () => {
  return (
    <section className="cloud-adoption-hero" role="banner" aria-labelledby="cloud-adoption-title">
      <div className="cloud-adoption-content-container">
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <header ref={ref} className={`cloud-adoption-content ${inView ? 'animate' : ''}`}>
              <h1 id="cloud-adoption-title">Cloud Adoption & Migration Solutions </h1>
              
            </header>
          )}
        </InView>
      </div>
    </section>
  );
};

export default CloudAdoptionHero;
